import { useAtom } from 'jotai';
import { LogIn, LogOut, ServerCog, AlertTriangle, X } from 'lucide-react';
import { eventToastsAtom, EventToast } from './eventToastAtom';

const STYLE: Record<EventToast['kind'], { icon: React.ReactNode; color: string }> = {
  join:   { icon: <LogIn className="h-4 w-4" />,          color: 'var(--sc-green)' },
  leave:  { icon: <LogOut className="h-4 w-4" />,         color: 'var(--sc-muted)' },
  server: { icon: <ServerCog className="h-4 w-4" />,      color: 'var(--sc-cyan)' },
  warn:   { icon: <AlertTriangle className="h-4 w-4" />,  color: 'var(--sc-warn)' },
};

export function EventToaster() {
  const [toasts, setToasts] = useAtom(eventToastsAtom);
  if (!toasts.length) return null;
  return (
    <div className="fixed bottom-4 right-4 z-[900] flex flex-col gap-2 w-[280px]" aria-live="polite">
      {toasts.map((t) => {
        const s = STYLE[t.kind];
        return (
          <div key={t.id} className="sc-glass sc-rise rounded-xl px-3 py-2.5 flex items-start gap-2.5"
            style={{ border: '1px solid var(--sc-border-mid)', boxShadow: 'var(--sc-glow-sm)' }}>
            <span className="mt-0.5 shrink-0" style={{ color: s.color }}>{s.icon}</span>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium truncate" style={{ color: 'var(--sc-text)' }}>{t.title}</div>
              {t.sub && <div className="text-xs truncate" style={{ color: 'var(--sc-muted)' }}>{t.sub}</div>}
            </div>
            <button onClick={() => setToasts((p) => p.filter((x) => x.id !== t.id))}
              className="shrink-0 opacity-40 hover:opacity-100 transition-opacity" style={{ color: 'var(--sc-muted)' }}>
              <X className="h-3.5 w-3.5" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
